<template>
  <div class="relative flex items-center group" :class="wrapperClass">
    <!-- Info Icon -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-4 w-4 text-gray-500 cursor-pointer"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
      />
    </svg>

    <!-- Tooltip content -->
    <div
      v-if="message"
      class="absolute z-50 hidden group-hover:flex px-2 py-1 text-xs rounded shadow bg-gray-800 text-white whitespace-nowrap"
      :class="tooltipPositionClass"
    >
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: "top", // default to top
      validator: (value) => ["top", "bottom", "left", "right"].includes(value),
    },
    wrapperClass: {
      type: String,
      default: "", // optional classes for outer div
    },
  },
  computed: {
    tooltipPositionClass() {
      switch (this.position) {
        case "top":
          return "bottom-full mb-1 left-1/2 transform -translate-x-1/2";
        case "bottom":
          return "top-full mt-1 left-1/2 transform -translate-x-1/2";
        case "left":
          return "right-full mr-1 top-1/2 transform -translate-y-1/2";
        case "right":
          return "left-full ml-1 top-1/2 transform -translate-y-1/2";
        default:
          return "bottom-full mb-1 left-1/2 transform -translate-x-1/2";
      }
    },
  },
};
</script>
